export default {
  guestNetwork: 'https://king.host/wiki/artigo/como-criar-uma-rede-guest-isolada/',
  publicIp: 'https://king.host/wiki/artigo/como-configurar-um-ip-publico-em-uma-vm/',
  sshKey: 'https://king.host/wiki/artigo/como-criar-configurar-e-usar-as-chaves-ssh-em-uma-vm/',
  virtualMachine: 'https://king.host/wiki/artigo/guia-completo-para-criar-uma-maquina-virtual-vm/',
  portForwarding: 'https://king.host/wiki/artigo/como-fazer-a-configuracao-do-encaminhamento-de-porta/',
  staticNat: 'https://king.host/wiki/artigo/como-configurar-um-nat-estatico-no-kinghost-cloud/',
  firewall: 'https://king.host/wiki/artigo/como-configurar-o-firewall-nas-maquinas-virtuais/',
  viaSsh: 'https://king.host/wiki/artigo/como-acessar-uma-vm-usando-o-ssh/',
  viaConsole: 'https://king.host/wiki/artigo/como-acessar-uma-maquina-virtual-vm-usando-o-console/',
  fullTutorial: 'https://king.host/wiki/artigo/como-preparar-o-ambiente-e-construir-a-primeira-vm-no-kinghost-cloud/'
}
